import { getLink } from '../../../../utils/utils';

import author from './author';

const content = {
	rus: (
		`
		<div class="poem">
			
			<p class="poem-block mb-3">
				Ночи, полные страха,<br/>
				Злые вопли сирены <br/>
				И ожидание краха,<br/>
				Что придёт непременно.<br/>
				Ночи пустых мечтаний, <br/>
				Ночи без сил, без мыслей, <br/>
				Ночи воспоминаний,<br/>
				Что в голове прокисли.<br/>
				Только тревога воет<br/>
				Да ПВО грохочет, <br/>
				Словно сказать нам хочет, <br/>
				Что умирать не сто́ит.
			</p>
		</div>
		`
	)
}

const itemName = {
	rus: 'Ночи, полные страха'
}
const itemLink = "Ночи полные страха";

const item = {
	itemlink: getLink(itemLink),
	rus:{
		itemName: itemName.rus,
		itemContent: content.rus,
		itemAuthor: author.rus
	}
}


export default item;